(function () {
  'use strict';

  var redirectingToYampi = false;

  function normalizePath(url) {
    try {
      return new URL(url, window.location.origin).pathname.replace(/\/+$/, '');
    } catch (error) {
      return url.replace(/\/+$/, '');
    }
  }

  function isCartCheckoutForm(form) {
    if (!form || form.nodeName !== 'FORM' || !form.querySelector('[name="checkout"]')) {
      return false;
    }

    var formAction = form.getAttribute('action') || '';
    var cartUrl = window.routes && window.routes.cartUrl ? window.routes.cartUrl : '/cart';

    return normalizePath(formAction) === normalizePath(cartUrl);
  }

  function isYampiActive() {
    return typeof window.yampiClick === 'function' &&
      typeof window.yampiCheckoutUrl === 'string' &&
      window.yampiCheckoutUrl.length > 0;
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;

    if (redirectingToYampi || !isYampiActive() || !isCartCheckoutForm(form)) {
      return;
    }

    if (event.submitter && event.submitter.name && event.submitter.name !== 'checkout') {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    redirectingToYampi = true;

    try {
      // yampiClick always requests /cart.json again, so the checkout receives
      // quantities and products changed through AJAX without a page reload.
      window.yampiClick();
    } catch (error) {
      redirectingToYampi = false;
      window.location.href = '/checkout';
    }
  }, true);
})();
